import player from './player'

const getScreenShot = function (width, height, callback) {
  let api = player.getApi()
  if (api) {
    api.getScreenShot(width, height, function (err, result) {
      if (callback != null && err === null) callback(result)
    })
  }
}

export default { getScreenShot }
